module.exports = __webpack_public_path__ + "img/top-logo.09ca0faa.png";